// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1atfD","importantInfo":"styles_importantInfo__1TIq4"};